import { capi } from '../../client';

export default {
  state: {
    componentizedTranslations: null,
  },

  getters: {
    componentizedTranslations: (state) => state.componentizedTranslations,
  },

  mutations: {
    componentizedTranslationsUpdate(state, fetchedTranslations) {
      // eslint-disable-next-line no-param-reassign
      state.componentizedTranslations = fetchedTranslations;
    },
  },

  actions: {
    async fetchComponentizedTranslations({ getters, commit }, query = {}) {
      try {
        const q = new URLSearchParams(query).toString();
        const { data, status } = await capi.get(`translations/${getters.locale}/?${q}`);

        if (data && status === 200) commit('componentizedTranslationsUpdate', data);
        else commit('componentizedTranslationsUpdate', null);
      } catch (e) {
        console.log(e);
        commit('componentizedTranslationsUpdate', null);
      }
    },
  },
};
